import { Dropdown, Space } from "antd";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  BinocularsLight,
  MoreIcon,
  NoDataIcon,
  PurpleFolderIcon,
} from "../../../constants/svg";
import LoadingScreen from "../../LoadingScreen/LoadingScreen";

const ResourceFolders = ({ onOpenFolder }) => {
  const { resourceFolders, isResourceFoldersLoading } = useSelector(
    (state) => state?.resources,
  );

  const folders = resourceFolders?.data || [];

  const actionMenu = (folder) => [
    {
      key: "1",
      label: (
        <div onClick={() => onOpenFolder?.(folder)}>
          <BinocularsLight />
          View
        </div>
      ),
    },
  ];

  return (
    <div className="custom-pl-15">
      <div className="resources-card-height">
        {isResourceFoldersLoading && <LoadingScreen child={true} />}

        {!isResourceFoldersLoading && !folders.length && (
          <Row>
            <Col md={12}>
              <div className="noSearchData">
                <NoDataIcon />
                <h5>No categories found.</h5>
                <h6>Categories you enable in Settings will appear here.</h6>
              </div>
            </Col>
          </Row>
        )}

        {!isResourceFoldersLoading && folders.length > 0 && (
          <div className="resource-folders-scroll">
            <Row>
              {folders.map((folder) => {
                const count = folder?.resources_count || 0;
                return (
                  <Col lg={4} xxl={3} key={folder.id}>
                    <div
                      className="resource_folder_box"
                      onClick={() => onOpenFolder?.(folder)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          onOpenFolder?.(folder);
                        }
                      }}
                    >
                      <div className="resource_folder_content">
                        <h5 className="black">{folder?.name}</h5>
                        <p>Folder</p>
                      </div>
                      <div className="resource_folder_footer">
                        <div className="resource_folder_meta">
                          <PurpleFolderIcon />
                          <span>
                            {count} {count === 1 ? "Resource" : "Resources"}
                          </span>
                        </div>
                        <Space size="middle">
                          <Dropdown
                            menu={{ items: actionMenu(folder) }}
                            placement="bottomRight"
                            trigger={["click"]}
                            overlayClassName={"defaultDropdown"}
                          >
                            <div
                              className="icon cursor-pointer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <MoreIcon />
                            </div>
                          </Dropdown>
                        </Space>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResourceFolders;
